/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `active` - 활성
 * `expired` - 만료
 * `cancelled` - 취소됨
 * `trial` - 체험
 */
export type SubscriptionStatusEnum =
  (typeof SubscriptionStatusEnum)[keyof typeof SubscriptionStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionStatusEnum = {
  active: "active",
  expired: "expired",
  cancelled: "cancelled",
  trial: "trial",
} as const;
